import { render, staticRenderFns } from "./edit-category.vue?vue&type=template&id=894bcb76"
import script from "./edit-category.vue?vue&type=script&lang=ts"
export * from "./edit-category.vue?vue&type=script&lang=ts"
import style0 from "./edit-category.vue?vue&type=style&index=0&id=894bcb76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports